<template>
  <div class="">
    <el-select ref="brands" v-model="brandId" @change="selectBrand" filterable :placeholder="brandPlaceholder">
      <el-option
        v-for="item in brands"
        :key="item.name"
        :label="item.name"
        :value="item.id">
      </el-option>
    </el-select>
    <el-select ref="series" v-model="seriesId" @change="selectSeries" filterable :placeholder="seriesPlaceholder">
      <el-option
        v-for="item in series"
        :key="item.name"
        :label="item.name"
        :value="item.id">
      </el-option>
    </el-select>

    <el-select ref="categories"  :multiple="categoriesMultiple" v-model="categoriesIds" @change="selectCategories" filterable :placeholder="categoriesPlaceholder">
      <el-option
        v-for="item in categories"
        :key="item.name"
        :label="item.name"
        :value="item.id">
      </el-option>
    </el-select>
  </div>

  <!-- /.navbar-static-side -->
</template>

<script>
import Config from '@/framework/configs/Config'
import BrandSeriesModel from '@/framework/models/brandSeriesModel'
export default {
  name: 'brand-and-series-categories-select',
  data: function () {
    return {
      baseImageUrl: Config.imageUrl,
      datas: [],
      brandId: null,
      brands: [],
      seriesId: null,
      series: [],
      categories: [],
      categoriesIds: [],
      props: {
        label: 'name',
        value: 'id',
        children: 'datas'
      },
      brandPosition: null,
      seariesPosition: null,
      categoriesPosition: null,
      areaCode: []
    }
  },
  mounted: function () {
    this.loadBrands()
  },
  props: {
    limit: {
      type: Number,
      default: 1
    },
    categoriesMultiple: {
      type: Boolean,
      default: true
    },
    businessId: {
      type: Number,
      default: null
    },
    brandPlaceholder: {
      type: String,
      default: '请选择品牌'
    },
    seriesPlaceholder: {
      type: String,
      default: '请选择车系'
    },
    categoriesPlaceholder: {
      type: String,
      default: '请选择车型'
    }
  },
  methods: {
    setValue: function (brandId, seriesId, categoryIds) {
      if (brandId) {
        this.brandId = brandId
        this.selectBrand(brandId)
      }

      if (seriesId) {
        this.seriesId = seriesId
        this.selectSeries(seriesId)
      }

      if (categoryIds) {
        if (this.categoriesMultiple) {
          let ids = categoryIds.split(',')
          let intIds = []

          for (var i = 0; i < ids.length; i++) {
            let id = ids[i]
            intIds.push(parseInt(id))
          }

          this.categoriesIds = intIds
        } else {
          this.categoriesIds = categoryIds
        }
      }
    },
    selectCategories: function (seriesId) {
      // 获取车系信息
      let seriesRef = this.$refs['series']
      let seriesSelectedLabel = seriesRef.selectedLabel
      // let position = seriesRef.hoverIndex
      let seriesInfo = null
      for (var i = 0; i < this.series.length; i++) {
        let serie = this.series[i]
        if (serie.name == seriesSelectedLabel) {
          seriesInfo = serie
        }
      }

      // 获取品牌信息
      let brandRefs = this.$refs['brands']
      let brandInfo = null
      let brandSelectedLabel = brandRefs.selectedLabel
      for (var i = 0; i < this.brands.length; i++) {
        let brand = this.brands[i]
        if (brand.name == brandSelectedLabel) {
          brandInfo = brand
        }
      }

      // let brandPosition = brandRefs.hoverIndex
      // let brandInfo = this.brands[brandPosition]

      let categoriesInfo = null

      if (this.categoriesMultiple) {
        // 获取品牌信息
        let categoriesArr = []

        let categories = this.categories
        let length = categories.length
        let categoriesIds = this.categoriesIds
        for (var i = 0; i < length; i++) {
          let categorie = categories[i]
          let id = categorie['id']
          let position = categoriesIds.indexOf(id)
          if (position != -1) {
            categoriesArr.push(categorie)
          }
        }

        categoriesInfo = categoriesArr
      } else {
        let categoriesRefs = this.$refs['categories']
        let categoriesPosition = categoriesRefs.hoverIndex
        categoriesInfo = this.categories[categoriesPosition]
      }

      if (seriesInfo && brandInfo && categoriesInfo) {
        this.$emit('onChanged', brandInfo, seriesInfo, categoriesInfo)
      }
    },
    selectBrand: function (brandId) {
      let _this = this

      if (!brandId) {
        return
      }

      this.series = []
      this.seriesId = null

      this.categories = []
      this.categoriesIds = []

      let params = {
        brandId: brandId,
        businessId: this.businessId
      }

      let listener = {
        success: function (dataInfo) {
          let datas = dataInfo.datas
          _this.series = datas
        }
      }
      BrandSeriesModel.findBaseSeriesByBrandIdForCDSystemByFilter(_this, params, listener)

      // 获取品牌信息
      let brandRefs = this.$refs['brands']
      let brandPosition = brandRefs.selected.index
      let brandInfo = this.brands[brandPosition]

      if (brandInfo) {
        this.$emit('onChanged', brandInfo)
      }
    },
    selectSeries: function (seriesId) {
      this.categories = []
      this.categoriesIds = []

      // 获取车系信息
      let seriesRef = this.$refs['series']
      let position = seriesRef.hoverIndex
      let seriesInfo = this.series[position]

      let _this = this
      let params = {
        seriesId: seriesId

      }

      let listener = {
        success: function (dataInfo) {
          let datas = dataInfo.datas
          _this.categories = datas
        }
      }
      BrandSeriesModel.getCategoryListBySeriesIdByFilter(_this, params, listener)

      // //获取品牌信息
      // let brandRefs = this.$refs['brands'];
      // let brandPosition = brandRefs.hoverIndex
      // let brandInfo = this.brands[brandPosition]

      // if(seriesInfo&&brandInfo){
      //   this.$emit('onChanged',brandInfo,seriesInfo)
      // }
    },
    clear: function () {
      this.areaCode = []
      this.brandPosition = null
      this.seariesPosition = null
      this.seriesId = null
      this.brandId = null
    },
    loadBrands: function () {
      let _this = this

      let params = {
        businessId: this.businessId
      }
      let listener = {
        success: function (dataInfo) {
          _this.brands = dataInfo.datas
        }
      }
      BrandSeriesModel.findBaseBrandForCDSystemByFilter(_this, params, listener)
    }
  }
}
</script>
